// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2OPB6","Label":"Input_Label__ghGD-","InputElement":"Input_InputElement__1IRXi","Invalid":"Input_Invalid__HZ4Fz"};